// extracted by mini-css-extract-plugin
export default {"container":"T03_water_container__RjF1Q","logo":"T03_water_logo__jXImU","limiter":"T03_water_limiter__mzwll","list":"T03_water_list__obHNq","icon":"T03_water_icon__kvIiB"};